import { API_BASE_URL } from "../config/api";

/**
 * Resolve API-stored media paths for <img src>.
 * Accepts absolute http(s)/data URLs, or relative /storage/... paths from Laravel.
 */
export function resolveMediaUrl(path) {
  if (path == null) return null;
  const value = String(path).trim();
  if (!value) return null;
  if (/^(https?:|data:)/i.test(value)) return value;
  if (value.startsWith("//")) return `${window.location.protocol}${value}`;

  const base = String(API_BASE_URL || "").replace(/\/$/, "");
  if (value.startsWith("/")) return `${base}${value}`;
  if (value.startsWith("storage/")) return `${base}/${value}`;
  return `${base}/storage/${value.replace(/^\//, "")}`;
}
